import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const SideMenuContainer = styled.div`
  overflow-y: auto;
  height: ${({ footerPlayerHeight }) =>
    `calc(100vh - 125px - ${footerPlayerHeight}px)}`};

  /* Scrollbar стили */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: green;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }

  /* Убираем стрелки у скроллбара */
  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.43) #3f3f3f;
`;

export const SideMenuInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  height: 100%;

  padding: 0 7px 0 24px;
`;

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px;

  @media ${breakpoints.xs} {
    padding: 0 16px 24px;
  }
  @media ${breakpoints.sm} and (orientation: landscape) {
    padding: 12px 16px;
  }
  @media (max-width: 390px) {
    padding: 0px 0 24px;
  }
`;

export const SideMenuList = styled.ul`
  margin-top: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SideMenuListItem = styled.li`
  margin-bottom: 16px;

  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 50ms ease-out;

  font-size: 20px;
  line-height: 140%;
  & svg {
    max-width: 24px;
    margin-right: 16px;
  }
  &:hover {
    color: #ed6c45;
    & svg > path {
      fill: #ed6c45;
    }
  }
  @media ${breakpoints.xs} {
    font-size: 16px;
  }
`;

export const SideMenuUserInner = styled.div`
  display: flex;
  align-items: center;
  & svg {
    margin-right: 16px;
  }
`;

export const SideMenuUserName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SideMenuLogOutInner = styled.div`
  display: flex;
  align-items: center;
  & svg {
    margin-right: 20px;
  }
`;

export const SideMenuLogOut = styled.div`
  font-size: 20px;
  line-height: 140%;
  color: #ff3737;
  cursor: pointer;
  line-height: 28px;
  @media ${breakpoints.xs} {
    font-size: 16px;
  }
`;

export const SideMenuTitle = styled.h3`
  display: block;
  font-family: "Inter", sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 28px;

  color: rgba(255, 255, 255, 0.9);
`;

export const SideMenuMiniTitle = styled.h4`
  display: block;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;

  color: rgba(255, 255, 255, 1);
`;

export const SideMenuDesc = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  align-self: stretch;
  white-space: pre-line;

  color: #ffffff;
`;

export const SideMenuForm = styled.form`
  margin-top: 24px;
  width: 100%;
`;

export const SideMenuTextArea = styled.textarea`
  width: 100%;
  height: 154px;
  resize: none;

  background: transparent;
  padding: 29px 25px;
  outline: 0;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 0px;

  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  font-size: 20px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  @media ${breakpoints.sm} {
    padding: 20px 24px;
  }
  @media (max-width: 390px) {
    padding: 14px 16px;
    font-size: 16px;
  }
`;

export const SideMenuMainBtn = styled.button`
  margin-top: 24px;
  padding: 22px;
  width: 100%;

  background: #d75b3c;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  text-transform: uppercase;
  transition: background 0.2s linear;
  &:hover {
    background: #ed6c45;
  }
  &:active {
    background: #d4603d;
  }
  &:disabled {
    opacity: 0.3;
  }
`;

export const ErrorAlert = styled.div`
  margin-top: 8px;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #ff3737;
`;

export const SideMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SideMenuContentInfo = styled.div``;

export const SideMenuContentInfoField = styled.div`
  margin-bottom: 16px;
  display: flex;

  color: rgba(255, 255, 255, 0.9);
`;

export const FieldName = styled.div`
  margin-right: 12px;
  width: 105px;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #919191;
`;

export const FieldDesc = styled.div`
  flex: 1 1 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`;

export const WhereToListenTitle = styled.h4`
  font-weight: 900;
  font-size: 20px;
  line-height: 150%;
`;

export const WhereToListen = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.9);
`;

export const WhereToListenIconWrapper = styled.div`
  padding: 16px 0;
  display: flex;

  & svg {
    margin-right: 32px;
    cursor: pointer;
  }
`;

export const SideMenuAlbumImg = styled.img`
  height: 77px;
  width: 77px;
  border-radius: 16px;
`;

export const LinkPodcast = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #f98723;
  text-decoration: underline;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: fit-content;
`;
